import BackButtonPage from '../../../../../components/BackButtonPage';
import "../../../../../styles/AdottTortenelmiPillanat.css"


function ProjekthezTampontokatAdo() {
  return (
    <div className='page-content-container'>
        <img src="/assets/ter_segedlet/abrazolasok1.png" className='responsive-img' alt="Ábrázolások 1" />
        <img src="/assets/ter_segedlet/abrazolasok2.png" className='responsive-img' alt="Ábrázolások 2" />
        <img src="/assets/ter_segedlet/abrazolasok3.png" className='responsive-img' alt="Ábrázolások 3" />
        <BackButtonPage to="/ter-segedlet" />
    </div>
  );
}

export default ProjekthezTampontokatAdo;
